import { render, staticRenderFns } from "./cadre-header.vue?vue&type=template&id=560cb81b&"
import script from "./cadre-header.ts?vue&type=script&lang=ts&"
export * from "./cadre-header.ts?vue&type=script&lang=ts&"
import style0 from "./cadre-header.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports